import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Speaker = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.963 1.615c.345.163.565.51.565.892v39.825a.987.987 0 0 1-1.613.764L8.527 32.152H.988A.988.988 0 0 1 0 31.164V13.675c0-.546.442-.988.988-.988h7.538L21.916 1.743a.988.988 0 0 1 1.048-.128Zm-1.41 2.976L9.503 14.44a.988.988 0 0 1-.625.223H1.976v15.513h6.903c.228 0 .449.08.626.224l12.047 9.848V4.591ZM27.606 5.94a.988.988 0 0 1 1.103-.857C37.326 6.158 44 13.513 44 22.42c0 8.92-6.675 16.261-15.304 17.336a.988.988 0 1 1-.245-1.96c7.654-.953 13.573-7.466 13.573-15.377 0-7.897-5.92-14.423-13.56-15.376a.988.988 0 0 1-.858-1.102Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.369 13.423a.988.988 0 0 1 1.167-.768c4.545.935 7.968 4.952 7.968 9.764 0 4.723-3.276 8.669-7.677 9.706a.988.988 0 1 1-.454-1.922 7.997 7.997 0 0 0 6.155-7.784c0-3.852-2.742-7.079-6.39-7.83a.988.988 0 0 1-.77-1.166Z"
  }));
});
Speaker.displayName = 'Speaker';
Speaker.defaultProps = {
  'aria-label': 'Speaker'
};
export default Speaker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Speaker.js
// module id = 3289
// module chunks = 11